module.exports = __webpack_public_path__ + "img/2.bfd2d459.png";